
const digest = 'c95d0dc14d72c73e10c8eebc055c630df64f0d9fde2ee94545aa236e36a0e7fe';
const classes = {"wrapper":"_wrapper_41sv4_1","invoices":"_invoices_41sv4_20","link":"_link_41sv4_25","state":"_state_41sv4_28","storno":"_storno_41sv4_31","send":"_send_41sv4_34","commission":"_commission_41sv4_37"};
const css = `._wrapper_41sv4_1 {
  color: #000000;
  font-size: 12px;
  font-weight: 400;
  background-color: #ffffff;
  border: 1px solid #eaedf3;
}
._wrapper_41sv4_1:nth-child(even) {
  background-color: #fbfbfd;
}
._wrapper_41sv4_1 td {
  padding: 14px 8px;
}
._wrapper_41sv4_1 td:first-of-type {
  padding-left: 14px;
}
._wrapper_41sv4_1 td:last-of-type {
  padding-right: 14px;
}
._wrapper_41sv4_1 ._invoices_41sv4_20 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
._wrapper_41sv4_1 ._invoices_41sv4_20 ._link_41sv4_25 {
  width: max-content;
}
._wrapper_41sv4_1 ._state_41sv4_28 {
  font-weight: 600;
}
._wrapper_41sv4_1 ._storno_41sv4_31 {
  color: #d81616;
}
._wrapper_41sv4_1 ._send_41sv4_34 {
  color: #f28a11;
}
._wrapper_41sv4_1 ._commission_41sv4_37 {
  font-weight: 600;
  color: #619612;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  